import { render, staticRenderFns } from "./sessionSelections.vue?vue&type=template&id=163d91d8"
import script from "./sessionSelections.vue?vue&type=script&lang=js"
export * from "./sessionSelections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports